import React from "react";
import "./style/DataUnitForm.css";
function DataUnitForm({ villa }) {
  return (
    <div className="data-form">
      <div className="data-items">
        <p className="card-title title-unit mb-1">{villa.code || "_"}</p>

        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">Tybe</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0">{villa.type?.name || "غير محدد"}</p>
          </div>
        </div>
        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">Land Area</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.land_area}</p>
          </div>
        </div>
        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">built-up Area</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.built_up_area}</p>
          </div>
        </div>
        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">price</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.actual_price}</p>
          </div>
        </div>

        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">Bathrooms</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.num_of_bathrooms}</p>
          </div>
        </div>
        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">Bedrooms</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.num_of_bedrooms}</p>
          </div>
        </div>

        
        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">Front Compass</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.direction}</p>
          </div>
        </div>
        <div className="item">
          <div className="name-data col-lg-6">
            <p className="m-0 p-0">Finish Date</p>
          </div>
          <div className="data-unit col-lg-6">
            <p className="m-0 p-0">{villa.progress_deadline}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataUnitForm;
